import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

export const GetAllAnvaeSherkatBimeh = createAsyncThunk('NoeSherkatBimeh/GetAllAnvaeSherkatBimeh', async () => {
  return await BasicInfoHttpGetService({
    url: `${_apiPathManagerConfig?.BasicInfo.NoeSherkatBimeh.GetAllAnvaeSherkatBimeh}`,
  });
});
